<template>
  <div class="content-grid content-grid--subpage">
    <Breadcrumbs :title="t(`routes.admin.children.organizations.addContact.name`)" />
    <BackLinkTitle :title="t(`routes.admin.children.organizations.addContact.name`)" />
    <Card >
        <ContactForm :id="props.organizationId" @formSubmit="handleSubmit" />
    </Card>
  </div>
</template>

<script lang="ts" setup>
import {useI18n} from "vue3-i18n";
import {useRouter} from "vue-router";
import {useContactService} from "@/inversify.config";
import {notifyError, notifySuccess} from "@/notify";
import {Contact} from "@/types/entities/contact";
import {IAddContactRequest} from "@/types/requests/addContactRequest";
import Breadcrumbs from "@/components/layout/Breadcrumbs.vue";
import BackLinkTitle from "@/components/layout/BackLinkTitle.vue";
import Card from "@/components/layout/Card.vue";
import ContactForm from "@/components/forms/ContactForm.vue";

// eslint-disable-next-line no-undef
const props = defineProps<{
    organizationId: string;
}>();

const {t} = useI18n()
const router = useRouter();
const contactService = useContactService()

async function handleSubmit(contact: Contact) {
    let succeededOrNotResponse = await contactService.addContact(contact as IAddContactRequest, props.organizationId)
    if (succeededOrNotResponse && succeededOrNotResponse.succeeded) {
        notifySuccess(t('validation.contact.add.success'))
        setTimeout(() => {
            router.back();
        }, 1500);
    } else {
        let errorMessages = succeededOrNotResponse.getErrorMessages('validation.contact.add');
        if (errorMessages.length == 0)
          notifyError(t('validation.contact.add.errorOccurred'))
        else
          notifyError(errorMessages[0])
    }
}
</script>
